import { Typography, Box, Button, Popover, useTheme, Backdrop, CircularProgress, Stack } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DescriptionIcon from '@mui/icons-material/Description'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

import {
  popoverStyles,
  boxContainerStyles,
  boxStyles,
  deleteButtonStyles,
  textStyles,
  buttonContainerStyles,
  subtaskStyles,
} from './style'
import { useState } from 'react'
import { renderColorByString } from './renderColorByString'
// const getThumbnail = url => {
//   if (/\.(jpe?g|png|gif)$/i.test(url)) {
//     return (
//       <Box
//         component='img'
//         src={url}
//         alt='task-file'
//         sx={{
//           width: '100%',
//           height: 45,
//           borderRadius: 1,
//           objectFit: 'cover',
//           transition: 'transform 0.2s ease',
//           //   '&:hover': {
//           //     transform: 'scale(1.15)',
//           //   },
//         }}
//       />
//     )
//   } else if (/\.pdf$/i.test(url)) {
//     return <PictureAsPdfIcon sx={{ fontSize: 45, color: 'text.secondary' }} />
//   } else if (/\.(doc|docx)$/i.test(url)) {
//     return <DescriptionIcon sx={{ fontSize: 45, color: 'text.secondary' }} />
//   } else {
//     return <DescriptionIcon sx={{ fontSize: 45, color: 'text.secondary' }} />
//   }
// }
const getThumbnail = attachment => {
  const url = attachment.thumbnailLink || attachment.url
  const mime = typeof attachment.mimeType === 'string' ? attachment.mimeType : ''
  const name = attachment.name?.toLowerCase() || ''

  if (mime?.startsWith('image/') || /\.(svg|png|jpe?g|gif)$/i.test(name)) {
    return (
      <Box
        component="img"
        src={url}
        alt={attachment.name}
        sx={{
          // width: '100%',
          // height: '100%',
          maxHeight: 40,
          borderRadius: 1,
          objectFit: 'cover',
          transition: 'transform 0.2s ease',
        }}
      />
    )
  } else if (mime === 'application/pdf' || name.endsWith('.pdf')) {
    return (
      <img
        src={attachment.thumbnailLink || PictureAsPdfIcon}
        alt="PDF File"
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'cover',
        }}
      />
    )
  } else if (mime.includes('word') || name.endsWith('.doc') || name.endsWith('.docx')) {
    return <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
  } else {
    return <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
  }
}
const TasksPopover = ({ id, open, anchorEl, onClose, handleConfirmDelete, selectedData, context, customPosition }) => {
  const theme = useTheme()
  const [isDeleting, setIsDeleting] = useState(false)
  const [showAllAttachments, setShowAllAttachments] = useState(false)
  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await handleConfirmDelete()
      await onClose()
      setIsDeleting(false)
    } catch (error) {
      setIsDeleting(false)

      console.log('Error deleting deal: ', error)
    }
  }
  return (
    <Backdrop open={open} sx={{ zIndex: theme.zIndex.drawer + 100 }}>
      <>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={onClose}
          anchorOrigin={{
            vertical: 'top', // Show above
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          sx={{
            ...popoverStyles(theme),
            // 👇 add conditional fallback
            ...(customPosition && {
              position: 'absolute',
              top: customPosition.top,
              left: customPosition.left,
              transform: 'translateX(-50%)',
            }),
          }}
        >
          <Box sx={boxContainerStyles(theme)}>
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <WarningIcon sx={{ color: 'crimson' }} />
                <Typography sx={{ fontWeight: 'bold', color: 'crimson' }}>Confirm Deletion</Typography>
              </Box>
              <Typography style={textStyles(theme)} sx={{ mb: 2 }}>
                Are you sure you want to permanently delete the following item(s) from Grobotic?
              </Typography>
              <Box sx={boxStyles(theme)}>
                {context === 'teamTasks' ? (
                  <TaskAltIcon
                    sx={{
                      // color: 'rgb(247, 63, 236)',
                      color: 'rgb(52, 211, 145)',
                      fontSize: 35,
                    }}
                  />
                ) : context === 'mtb' ? (
                  <CalendarMonthIcon
                    sx={{
                      color: theme.palette.icon.mtb,
                      fontSize: 35,
                    }}
                  />
                ) : (
                  <EmojiObjectsIcon
                    sx={{
                      color: 'rgb(111, 31, 223)',
                      fontSize: 35,
                    }}
                  />
                )}

                <Typography style={textStyles(theme)}>{selectedData ? selectedData.name : ''}</Typography>
                {selectedData?.SK && selectedData?.SK?.startsWith('SUBTASK_') ? (
                  <Typography sx={{ color: theme.palette.text.secondary, fontStyle: 'italic' }}>Subtask</Typography>
                ) : null}
              </Box>
              {selectedData?.imageUrls && selectedData?.imageUrls?.length > 0 && (
                <Box sx={{ ...boxStyles(theme), gap: 1, justifyContent: 'center' }}>
                  {selectedData?.imageUrls?.map((url, index) => {
                    return <Box key={`${url}-${index}`}>{getThumbnail(url)}</Box>
                  })}
                </Box>
              )}
              {selectedData?.fileUrls && selectedData?.fileUrls?.length > 0 && (
                <Box sx={{ ...boxStyles(theme), gap: 1, justifyContent: 'center' }}>
                  {selectedData?.fileUrls?.map((url, index) => {
                    return <Box key={`${url}-${index}`}>{getThumbnail(url)}</Box>
                  })}
                </Box>
              )}
              {Array.isArray(selectedData?.notes) &&
                selectedData.notes.map((note, noteIndex) => {
                  if (!note.attachments || note.attachments.length === 0) return null

                  return (
                    <Box key={`note-${note.note_id || noteIndex}`} sx={{ ...boxStyles(theme), gap: 1, mt: 1 }}>
                      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 0.5 }}>
                        Note Attachments:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          flexWrap: 'wrap',
                          justifyContent: 'center',
                          maxHeight: showAllAttachments ? 'auto' : 100,
                          overflowY: 'auto',
                          overflowX: 'hidden',
                          p: 1,
                        }}
                      >
                        {note.attachments
                          .slice(0, showAllAttachments ? note.attachments.length : 6)
                          .map((attachment, index) => (
                            <Box key={`attachment-${index}`} sx={{ width: 45, height: 45 }} title={attachment.name}>
                              {getThumbnail(attachment)}
                            </Box>
                          ))}
                      </Box>

                      {note.attachments.length > 6 && (
                        <Box
                          sx={{
                            cursor: 'pointer',
                            color: theme.palette.primary.main,
                            fontSize: 12,
                            textAlign: 'center',
                            textDecoration: 'underline',
                            mt: 0.5,
                          }}
                          onClick={() => setShowAllAttachments(prev => !prev)}
                        >
                          {showAllAttachments ? 'Show Less' : 'View All Attachments'}
                        </Box>
                      )}
                    </Box>
                  )
                })}

              {selectedData?.subtasks && selectedData?.subtasks?.length > 0 && (
                <Stack sx={{ ...subtaskStyles(theme), gap: 1, justifyContent: 'center' }}>
                  {selectedData?.subtasks?.map(subtask => (
                    <Box
                      key={subtask?.SK}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        gap: 1,
                      }}
                    >
                      <Box>{subtask?.name}</Box>
                      <Box sx={{ color: renderColorByString(subtask?.masterStatus) }}>{subtask?.masterStatus}</Box>
                    </Box>
                  ))}
                </Stack>
              )}
            </>

            <Box sx={buttonContainerStyles(theme)}>
              {isDeleting && <CircularProgress />}
              <Button
                sx={deleteButtonStyles(theme)}
                variant="outlined"
                onClick={handleDelete}
                color="secondary"
                disabled={isDeleting}
              >
                Confirm
              </Button>
              <Button variant="contained" onClick={onClose}>
                Cancel
              </Button>
            </Box>
          </Box>
        </Popover>
      </>
    </Backdrop>
  )
}
export default TasksPopover
